<template>
  <v-card class="ma-2">
    <v-card-title>Adjuntos {{ mandatory ? "(Obligatorio)" : "" }}</v-card-title>
    <v-card-subtitle v-if="formType == 'sat'">Seleccione archivos para ayudar a resolver su incidencia. Puede seleccionar varios archivos como imágenes, videos, audios, pdf...</v-card-subtitle>
    <v-card-subtitle v-if="formType == 'logistics'">Es imprescindible que adjunte fotografías con detalle de los daños ocasionados tanto en el producto como en el embalaje.</v-card-subtitle>
    <v-file-input
        chips
        counter
        multiple
        show-size
        v-on:change="onFileChange"
        truncate-length="50"
        ></v-file-input>
  </v-card>
</template>

<script>
export default {
  name: "UploadFiles",
  props: ["formType", "mandatory"],
  data() {
    return {
      rules: {
        required: value => !!value && this.mandatory || 'Es obligatorio aceptar los términos y condiciones.'
      }
    }
  },
  methods: {
    onFileChange(e) {
        this.$emit("change", e);
    }
  }
}
</script>

<style scoped>

</style>